'use client'

import { useState } from 'react'
import { Button, Icon } from '@repo/ui/components'
import { CryptoQrCodeModal } from './crypto.qr-code-modal'

interface CryptoQrCodeButtonProps {
  value: string
  networkName?: string
  networkBadge?: string
  networkIcon?: React.ReactNode
}

export const CryptoQrCodeButton = ({
  value,
  networkName,
  networkBadge,
  networkIcon,
}: CryptoQrCodeButtonProps) => {
  const [qrCodeOpen, setQrCodeOpen] = useState(false)

  return (
    <>
      <Button
        onClick={() => setQrCodeOpen(true)}
        color='neutral'
        size='sm'
        variant='ghost'
        className='w-[32px]'
        type='button'
        startIcon={<Icon name='BoxLine' size='sm' />}
      />

      <CryptoQrCodeModal
        open={qrCodeOpen}
        onOpenChange={setQrCodeOpen}
        value={value}
        networkName={networkName}
        networkBadge={networkBadge}
        networkIcon={networkIcon}
      />
    </>
  )
}
